export default {
    //Home page - Header
    "production": "Продукция",
}